export default "__VITE_ASSET__1afc8153__"